import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Field, notify} from 'shared';
import {FieldService} from '../../stores/field.service';

@Component({
  selector: 'app-field-form',
  templateUrl: './field-form.component.html',
  styleUrls: ['./field-form.component.scss']
})
export class FieldFormComponent implements OnInit {

  @Input()
  field: Field;

  @Output()
  save = new EventEmitter<void>();

  changes: Partial<Field> = {};

  buttonOptions: any = {
    text: 'Sauvegarder',
    type: 'default',
    stylingMode: 'text',
    useSubmitBehavior: true
  };

  constructor(
    private fieldService: FieldService,
  ) {
    // Bindings
    this.codeValidation = this.codeValidation.bind(this);
  }

  ngOnInit(): void {
  }

  onFormSubmit(e: Event) {
    e.preventDefault();
    if (Object.keys(this.changes).length === 0) {
      return;
    }
    if (this.field.id) {
      this.fieldService.update(this.field.id, this.changes as Field).subscribe(() => {
        notify('Modifications enregistrées avec succès');
        this.save.emit();
        this.changes = {};
      });
    } else {
      const data = Object.assign({}, this.field);
      // @ts-ignore
      delete data._layer;
      // @ts-ignore
      delete data._geojson;
      console.log(data);
      this.fieldService.insert(data).subscribe(id => {
        notify('Modifications enregistrées avec succès');
        this.field.id = id;
        this.changes = {};
        this.save.emit();
      });
    }
  }

  addFormChange(e: any) {
    this.changes[e.dataField] = e.value;
  }

  domainChange(id: number) {
    this.changes.domain_id = id;
    this.field.domain_id = id;
  }

  codeValidation(params: any) {
    return this.fieldService.checkCode(params.value, this.field?.id).toPromise();
  }
}
